import createAsyncLocalStorage from './defaults/asyncLocalStorage';

export var asyncLocalStorage = createAsyncLocalStorage('local');
export var asyncSessionStorage = createAsyncLocalStorage('session');


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-persist/es/defaultStorages.js
// module id = 4419
// module chunks = 25